module.exports = __webpack_public_path__ + "static/media/file-download.15692bf9.svg";